<script>
	import { styles } from '../scripts/styles'

	export let column = '200px'
	export let backgroundColor = 'transparent'
	export let alignHorizontal = 'center'
	export let alignVertical = 'center'
	export let padding = '0%'
</script>

<!-- two columns layout  -->
<div use:styles={{ column, backgroundColor, alignHorizontal, alignVertical, padding }} class="container">
	<div><slot name="column1" /></div>
	<div><slot name="column2" /></div>
	<div><slot name="column3" /></div>
</div>

<style>
	.container {
		display: grid;
		width: 100%;
		grid-template-columns: repeat(auto-fit, minmax(var(--column), 1fr));
		justify-content: var(--alignHorizontal);
		align-items: var(--alignVertical);
		background-color: var(--backgroundColor);
		column-gap: 5vw;
		row-gap: 2vh;
		padding: var(--padding);
	}
</style>
